import { render, staticRenderFns } from "./translations.vue?vue&type=template&id=5ba48f42&"
import script from "./translations.vue?vue&type=script&lang=ts&"
export * from "./translations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports